import { AlkLogger } from '@alk/core';
import { EAuthenticationMode } from '../../enums';
import { IAuthenticationService } from './authentication.interface';
import { IAuthenticationTokens, IError, IJWT, IUserAuthentication } from '../../interfaces';
import { injectable } from 'inversify';
import { USER_01 } from '../../mocks/user.data';

@injectable()
export class AuthenticationMock implements IAuthenticationService {
    login(): Promise<[ IJWT, IError? ]> {
        AlkLogger.info('[AuthenticationMock] login()');

        sessionStorage.setItem('SFX_IS_LOGGED', 'true');
        sessionStorage.setItem('SFX_AUTH_MODE', 'mock');

        return Promise.resolve([ 'TokenJWT' as IJWT ]);
    }

    logout(): Promise<void> {
        AlkLogger.info('[AuthenticationMock] logout()');

        sessionStorage.setItem('SFX_IS_LOGGED', 'false');
        sessionStorage.removeItem('SFX_AUTH_MODE');

        location.href = '/';
        location.reload();

        return Promise.resolve();
    }

    isLogged(): Promise<boolean> {
        AlkLogger.info('[AuthenticationMock] isLogged()');

        return Promise.resolve(Boolean(JSON.parse(sessionStorage.getItem('SFX_IS_LOGGED'))));
    }

    refresh(): Promise<void> {
        AlkLogger.info('[AuthenticationMock] refresh()');
        return Promise.resolve();
    }

    getCurrentUser(): Promise<IUserAuthentication> {
        return Promise.resolve(USER_01);
    }

    getToken(): IAuthenticationTokens {
        AlkLogger.info('[AuthenticationMock] getToken()');
        return { access_token: 'TokenJWT' } as IAuthenticationTokens;
    }

    getAuthenticationMode(): EAuthenticationMode {
        return sessionStorage.getItem('SFX_AUTH_MODE') as EAuthenticationMode;
    }
}
